import { useHistory } from 'react-router-dom'

import { PreviewPix } from './PreviewPix'
import { PreviewFrame } from './PreviewFrame'
import { PreviewCrypto } from './PreviewCrypto'
import { PreviewMessage } from './PreviewMessage'

import { isProduction } from '../../settings'
import { isMobileDevice, redirectToExternalUrl } from 'mmfintech-commons'
import { useEventTracker } from 'mmfintech-checkout-commons'

export const DepositResult = ({ response, sessionId, onBack }) => {
  const { result, resultType, processingAmount, status } = response || {}

  const history = useHistory()

  const { trackEvent } = useEventTracker()

  if (status === 'FAILED') {
    history.push('/fail')
    return
  }

  const redirectToProvider = () => {
    trackEvent(sessionId, 'redirected_to_provider')
    redirectToExternalUrl(result)
  }

  switch (resultType) {
    // case 'INSTRUCTIONS':
    // case 'BANKWIRE_DETAILS':
    // case 'INTERNAL_EXECUTION':

    case 'MESSAGE':
      return <PreviewMessage result={result} />

    case 'REDIRECT_URL':
      redirectToProvider()
      break

    case 'QR_CODE':
      return <PreviewPix value={result} />

    // case 'CRYPTO_ADDRESS_DETAILS':
    case 'CHECKOUT_CRYPTO_ADDRESS_DETAILS':
      return <PreviewCrypto data={{ ...result, ...{ processingAmount } }} onBack={onBack} />

    case 'IFRAME_URL':
      if (isMobileDevice()) {
        redirectToProvider()
      } else {
        trackEvent(sessionId, 'open_provider_in_frame')
        return <PreviewFrame url={result} />
      }
      break

    default:
      if (!isProduction && resultType) {
        console.log(`DepositResult: Unknown result type "${resultType}"`)
      }
  }

  return null
}
